import React, { ReactNode } from "react"
import "./Header.scss";

export interface HeaderProps {
    children: ReactNode; 
}

export function Header(props: HeaderProps){
    return (
        <thead className={"header-container"}>
            <tr className={"header-row"}>
                {props.children}
            </tr>
        </thead>
    )

}